import the from '../objects/the';

interface HorizontalBarProps {
    color: string
    height: number
}

const HorizontalBar = (props: HorizontalBarProps) => {
    return <>
        <div style={{
            backgroundColor: props.color,
            height: props.height,
        }}></div>
    </>;
};

HorizontalBar.defaultProps = {
    color: the.color.forestGreen,
    height: 5,
};

export default HorizontalBar;